export const progressItems = [
  { message: "Generating questions...", icon: "fas fa-question-circle" },
  { message: "Generating voices...", icon: "fas fa-microphone-alt" },
  { message: "Asking Voldemort for advice...", icon: "fas fa-hat-wizard" },
  { message: "Conjuring up magic...", icon: "fas fa-magic" },
  { message: "Summoning creative energies...", icon: "fas fa-bolt" },
  { message: "Mixing potions...", icon: "fas fa-flask" },
  { message: "Consulting the crystal ball...", icon: "fas fa-eye" },
  { message: "Sharpening quills...", icon: "fas fa-pen-nib" },
  { message: "Counting goblins...", icon: "fas fa-calculator" },
  { message: "Taming dragons...", icon: "fas fa-dragon" },
  { message: "Unlocking secrets...", icon: "fas fa-key" },
  { message: "Herding unicorns...", icon: "fas fa-horse" },
  { message: "Summoning the muses...", icon: "fas fa-theater-masks" },
  { message: "Brewing ideas...", icon: "fas fa-coffee" },
  { message: "Reading ancient scrolls...", icon: "fas fa-scroll" },
  { message: "Navigating the maze...", icon: "fas fa-compass" },
  { message: "Mixing colors...", icon: "fas fa-palette" },
  { message: "Hitting the brainstorm button...", icon: "fas fa-brain" },
  { message: "Asking Merlin for help...", icon: "fas fa-hat-wizard" },
  { message: "Charting the stars...", icon: "fas fa-star" },
  { message: "Whispering to the winds...", icon: "fas fa-wind" },
  { message: "Decoding ancient runes...", icon: "fas fa-language" },
  { message: "Consulting the ancient tomes...", icon: "fas fa-book" },
  { message: "Forging mystical links...", icon: "fas fa-link" },
  { message: "Translating enchanted texts...", icon: "fas fa-language" },
  { message: "Stirring the cauldron...", icon: "fas fa-mortar-pestle" },
  { message: "Bending reality...", icon: "fas fa-universal-access" },
  { message: "Unleashing creative chaos...", icon: "fas fa-fire" },
  { message: "Deciphering runic symbols...", icon: "fas fa-spell-check" },
  { message: "Weaving digital enchantments...", icon: "fas fa-network-wired" },
  { message: "Infusing code with magic...", icon: "fas fa-code" },
  { message: "Scribing runes...", icon: "fas fa-pen" },
  { message: "Charging mystical batteries...", icon: "fas fa-battery-full" },
  { message: "Summoning pixel sprites...", icon: "fas fa-puzzle-piece" },
  { message: "Harmonizing digital incantations...", icon: "fas fa-music" },
  { message: "Empowering the code with life...", icon: "fas fa-heart" },
  { message: "Balancing mystical algorithms...", icon: "fas fa-balance-scale" },
  { message: "Recalibrating magic circuits...", icon: "fas fa-cogs" },
  { message: "Releasing the digital genie...", icon: "fas fa-lightbulb" },
  { message: "Whipping up creative storms...", icon: "fas fa-cloud-showers-heavy" },
  { message: "Manifesting dreams into code...", icon: "fas fa-feather-alt" },
  { message: "Invoking the spirit of innovation...", icon: "fas fa-rocket" },
  { message: "Channeling the muse...", icon: "fas fa-feather" },
  { message: "Enlightening the digital realm...", icon: "fas fa-sun" },
  { message: "Riding the comet of creativity...", icon: "fas fa-rocket" },
  { message: "Lighting up the code cosmos...", icon: "fas fa-star" },
  { message: "Smoothing out the glitches...", icon: "fas fa-tools" },
  { message: "Sharpening the code's edge...", icon: "fas fa-cut" },
  { message: "Tuning the digital orchestra...", icon: "fas fa-music" },
  { message: "Refining mystical blueprints...", icon: "fas fa-drafting-compass" },
  { message: "Harvesting ideas from the ether...", icon: "fas fa-leaf" },
  { message: "Infusing magic into every line...", icon: "fas fa-fire" },
  { message: "Casting spells of efficiency...", icon: "fas fa-magic" },
  { message: "Bridging realms of thought...", icon: "fas fa-project-diagram" },
  { message: "Unlocking the gates of creativity...", icon: "fas fa-key" },
  { message: "Polishing the gem of innovation...", icon: "fas fa-gem" },
];
